const personalityValues = {
    number: "1/1",
    question: "Values",
    description: `What are the core values that you bring to the table that are not your product per-se, but are embedded in the way that you offer your product/service? This is where your core team's values come into play as well.`
}

export const questions = {
    personalityValues: personalityValues,
}

const personalityValuesVideo = {
    url: "https://www.dropbox.com/scl/fi/spp6tonptltckp46kx2oz/19-Personality-and-Charisma.mp4?rlkey=r30z49ua6xlo0m3u0zzcd8tgw&raw=1"
}

export const videos = {
    personalityValuesVideo: personalityValuesVideo,
}